/* Frost — PDP "Discover more" rail (sections/frost-pdp-discover.liquid):
   desktop prev/next arrows (one card per click, hidden at either end and
   when nothing overflows), mobile page dots, and the card heart (saved in
   the same browser-storage list as the main product section's heart).
   Add to cart is handled by <product-form> (assets/product-form.js). */
(function () {
  var WISHLIST_KEY = 'fz-wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }

  function initRail(root) {
    if (root.dataset.fzDiscInit) return;
    root.dataset.fzDiscInit = 'true';

    var wrap = root.querySelector('[data-fz-disc-wrap]');
    var rail = root.querySelector('[data-fz-disc-rail]');
    var prev = root.querySelector('[data-fz-disc-prev]');
    var next = root.querySelector('[data-fz-disc-next]');
    var dotsEl = root.querySelector('[data-fz-disc-dots]');
    if (!rail) return;

    function step() {
      var card = rail.firstElementChild;
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function pageCount() {
      return Math.max(1, Math.round(rail.scrollWidth / Math.max(1, rail.clientWidth)));
    }

    function buildDots() {
      if (!dotsEl) return;
      var count = pageCount();
      if (dotsEl.children.length === count) return;
      dotsEl.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fz-disc__dot';
        dot.tabIndex = -1;
        dot.dataset.page = i;
        dot.addEventListener('click', function (e) {
          var page = Number(e.currentTarget.dataset.page);
          rail.scrollTo({ left: page * rail.clientWidth, behavior: 'smooth' });
        });
        dotsEl.appendChild(dot);
      }
    }

    function refresh() {
      var overflow = rail.scrollWidth - rail.clientWidth > 4;
      root.classList.toggle('fz-disc--no-overflow', !overflow);
      root.classList.toggle('fz-disc--centered', !overflow);

      // arrows sit level with the middle of the card photos
      var media = rail.querySelector('.fz-dc__media');
      if (media && wrap) wrap.style.setProperty('--fz-disc-arrow-top', Math.round(media.offsetHeight / 2) + 'px');

      var atStart = rail.scrollLeft <= 2;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      buildDots();
      if (dotsEl) {
        var active = atEnd ? dotsEl.children.length - 1 : Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
        Array.prototype.forEach.call(dotsEl.children, function (d, i) { d.classList.toggle('is-active', i === active); });
      }
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    // A mouse wheel moving vertically should scroll the page, not get
    // swallowed by this sideways-only row (same as the homepage rails).
    rail.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        window.scrollBy(0, e.deltaY);
      }
    }, { passive: false });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; refresh(); });
    }, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    refresh();

    // hearts
    var saved = readWishlist();
    root.querySelectorAll('[data-fz-dc-wishlist]').forEach(function (btn) {
      var id = String(btn.dataset.productId);
      function paint(on) {
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      paint(saved.indexOf(id) !== -1);
      btn.addEventListener('click', function () {
        var list = readWishlist();
        var i = list.indexOf(id);
        if (i === -1) list.push(id); else list.splice(i, 1);
        try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
        paint(i === -1);
      });
    });
  }

  function init() {
    // rails filled in later by script (Recently viewed) opt out with
    // data-fz-disc-defer and call window.FzDiscRail.init() themselves
    document.querySelectorAll('[data-fz-disc]:not([data-fz-disc-defer])').forEach(initRail);
  }

  window.FzDiscRail = { init: initRail };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
